<button
  class="button button-secondary"
  [ngClass]="{ hidden: experienceCounter <= loadMaxExperience * loaderCounter }"
  (click)="onLoadMoreClick()"
>
  <span *ngIf="buttonText">{{ buttonText }}</span>
  <span *ngIf="!buttonText">{{ 'label.load-more' | translate }}</span>
</button>
